import { render, staticRenderFns } from "./VideoSearch.vue?vue&type=template&id=8e65b2bc&scoped=true&"
import script from "./VideoSearch.vue?vue&type=script&lang=js&"
export * from "./VideoSearch.vue?vue&type=script&lang=js&"
import style0 from "./VideoSearch.vue?vue&type=style&index=0&id=8e65b2bc&prod&scoped=true&lang=css&"
import style1 from "./VideoSearch.vue?vue&type=style&index=1&id=8e65b2bc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e65b2bc",
  null
  
)

export default component.exports